import { Link } from 'react-router-dom';
import { useTranslation } from '../../../i18n';

const LINK_CLS =
  'text-field font-medium text-brand-600 hover:underline dark:text-brand-400 touch-manipulation';

export function SeeAlsoLinks() {
  const { t } = useTranslation();

  return (
    <nav
      aria-label={t('gest:admin.remuneration.config.seeAlso.title')}
      className="flex flex-col gap-2 border-t border-slate-200 pt-4 dark:border-slate-700"
    >
      <h3 className="text-body font-semibold text-slate-800 dark:text-slate-100">
        {t('gest:admin.remuneration.config.seeAlso.title')}
      </h3>
      <p className="text-meta text-slate-500 dark:text-slate-400">
        {t('gest:admin.remuneration.config.seeAlso.reason')}
      </p>
      <ul className="flex flex-col gap-1.5">
        <li>
          <Link to="/grille-salariale" className={LINK_CLS}>
            {t('gest:admin.remuneration.config.seeAlso.grille')}
          </Link>
          <span className="text-chip text-slate-500 dark:text-slate-400">
            {' — '}
            {t('gest:admin.remuneration.config.seeAlso.grilleWhy')}
          </span>
        </li>
        <li>
          <Link to="/grille-salariale/reel" className={LINK_CLS}>
            {t('gest:admin.remuneration.config.seeAlso.reel')}
          </Link>
          <span className="text-chip text-slate-500 dark:text-slate-400">
            {' — '}
            {t('gest:admin.remuneration.config.seeAlso.reelWhy')}
          </span>
        </li>
        <li>
          <Link to="/admin?tab=teams" className={LINK_CLS}>
            {t('gest:admin.remuneration.config.seeAlso.teams')}
          </Link>
          <span className="text-chip text-slate-500 dark:text-slate-400">
            {' — '}
            {t('gest:admin.remuneration.config.seeAlso.teamsWhy')}
          </span>
        </li>
        <li>
          <Link to="/admin?tab=contrats" className={LINK_CLS}>
            {t('gest:admin.remuneration.config.seeAlso.contrats')}
          </Link>
          <span className="text-chip text-slate-500 dark:text-slate-400">
            {' — '}
            {t('gest:admin.remuneration.config.seeAlso.contratsWhy')}
          </span>
        </li>
      </ul>
    </nav>
  );
}
